import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { UnidadOrganizacional } from '../../models/UnidadOrganizacional';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlantillasMemosService } from '../../services/plantillas-memos.service';
import { UnidadOrganizacionalService } from '../../services/unidad-organizacional.service';
import { PlantillaMemo } from '../../models/PlantillaMemo';

@Component({
    selector: 'app-dlg-update-plantilla-memo',
    imports: [
        MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent,
        ReactiveFormsModule,
        MatFormFieldModule, MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule, MatOptionModule
    ],
    templateUrl: './dlg-update-plantilla-memo.component.html',
    styleUrl: './dlg-update-plantilla-memo.component.scss'
})
export class DlgUpdatePlantillaMemoComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<DlgUpdatePlantillaMemoComponent>)
  readonly data = inject<PlantillaMemo>(MAT_DIALOG_DATA);

  plantillaMemo: PlantillaMemo

  fetchingUpdateTemplateMemo = false
  snackbarData: ScnackbarData = {}

  updateTemplateMemo = new FormGroup({
    codigoDepartamento: new FormControl("", {
      validators: [Validators.required]
    }),
    nombrePlantilla: new FormControl("", {
      validators: [Validators.required]
    }),
    descripcion: new FormControl("", {
      validators: [Validators.required]
    }),
    definicionCampo: new FormControl("", {
      validators: [Validators.required]
    }),
  })

  departamentos: UnidadOrganizacional[] = []

  constructor(
    private toast: ToastService,
    private unidadOrganizacionalService: UnidadOrganizacionalService,
    private plantillasMemosService: PlantillasMemosService
  ) {
    this.plantillaMemo = structuredClone(this.data)
  }

  ngOnInit(): void {
    this.unidadOrganizacionalService.listDepartamentos().subscribe({
      next: (response) => {
        this.departamentos = response
        this.initForm()
      }
    })

  }

  initForm() {
    this.updateTemplateMemo.controls.codigoDepartamento.setValue(this.plantillaMemo.codigoDpto)
    this.updateTemplateMemo.controls.definicionCampo.setValue(this.plantillaMemo.definicCampo)
    this.updateTemplateMemo.controls.nombrePlantilla.setValue(this.plantillaMemo.nomPlantilla)
    this.updateTemplateMemo.controls.descripcion.setValue(this.plantillaMemo.descripcion)
  }

  updateTemplateMemoHandler() {
    const controls = this.updateTemplateMemo.controls
    const plantillaMemo: PlantillaMemo = {
      codigoPtlMemo: this.plantillaMemo.codigoPtlMemo,
      codigoDpto: controls.codigoDepartamento.getRawValue()!,
      definicCampo: controls.definicionCampo.getRawValue()!,
      nomPlantilla: controls.nombrePlantilla.getRawValue()!,
      descripcion: controls.descripcion.getRawValue()!,
    }
    this.plantillasMemosService.patch(plantillaMemo).subscribe({
      next: (response) => {
        this.snackbarData.message = "Plantilla memo actualizada"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.toast.show(this.snackbarData)
        this.fetchingUpdateTemplateMemo = false
        this.dialogRef.close(response)
      },
      error: () => {
        this.snackbarData.message = "Error actualizando plantilla memo"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData)
        this.fetchingUpdateTemplateMemo = false
        this.dialogRef.close(null)
      }
    })
  }

}
